import React from 'react';
import { useTranslation } from 'react-i18next';
import { TransferSkill } from '../../hooks/useTransferData';
import styles from './TransferPanelList.module.css';

interface TransferQueueTabProps {
  skills: TransferSkill[];
  filteredSkills: TransferSkill[];
  searchQuery: string;
  onSearchChange: (query: string) => void;
  onSelectSkill: (skill: TransferSkill) => void;
}

export function TransferQueueTab({
  skills,
  filteredSkills,
  searchQuery,
  onSearchChange,
  onSelectSkill,
}: TransferQueueTabProps) {
  const { t } = useTranslation();

  return (
    <>
      <div className={styles.searchBox}>
        <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
          <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
        </svg>
        <input
          type="text"
          placeholder={t('call:transfer.searchQueues')}
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className={styles.searchInput}
        />
      </div>
      <div className={styles.list}>
        {filteredSkills.length === 0 ? (
          <div className={styles.emptyState}>
            {skills.length === 0
              ? t('call:transfer.noQueuesAvailable')
              : t('call:transfer.noMatchingQueues')}
          </div>
        ) : (
          filteredSkills.map((skill) => (
            <button
              key={skill.skillId}
              className={styles.listItem}
              onClick={() => onSelectSkill(skill)}
            >
              <div className={styles.itemIcon}>
                <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
                  <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 3c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm7 13H5v-.23c0-.62.28-1.2.76-1.58C7.47 15.82 9.64 15 12 15s4.53.82 6.24 2.19c.48.38.76.97.76 1.58V19z" />
                </svg>
              </div>
              <div className={styles.itemText}>
                <span className={styles.itemName}>{skill.skillName}</span>
                {skill.mediaType && <span className={styles.itemMeta}>{skill.mediaType}</span>}
              </div>
              <svg
                className={styles.itemArrow}
                viewBox="0 0 24 24"
                width="16"
                height="16"
                fill="currentColor"
              >
                <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" />
              </svg>
            </button>
          ))
        )}
      </div>
    </>
  );
}
